import { Info, Layers, Sprout } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export function PositionsVsNeedsDialog() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button
          type="button"
          data-testid="positions-vs-needs-info-button"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm border border-[#4A5D4E]/30 text-[#4A5D4E] hover:bg-[#F5F2EA] transition-all shrink-0"
        >
          <Info className="h-4 w-4" strokeWidth={1.75} /> Positions vs. needs
        </button>
      </DialogTrigger>
      <DialogContent className="bg-[#FDFBF7] border-[#E8E3D9] max-w-lg" data-testid="positions-vs-needs-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-[#2D2A26]">Positions vs. needs</DialogTitle>
        </DialogHeader>
        <div className="space-y-5 text-[#2D2A26] leading-relaxed text-sm">
          <div className="flex gap-3">
            <span className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#F5F2EA]">
              <Layers className="h-4 w-4 text-[#C4A265]" strokeWidth={1.5} />
            </span>
            <p>
              <span className="font-semibold">A position</span> is the specific stance or solution someone
              argues for — “ban it,” “allow it,” “build the wall,” “raise the wage.” It's what people
              <em> say</em> they want, and it's usually where arguments get stuck.
            </p>
          </div>
          <div className="flex gap-3">
            <span className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#F5F2EA]">
              <Sprout className="h-4 w-4 text-[#4A5D4E]" strokeWidth={1.5} />
            </span>
            <p>
              <span className="font-semibold">A need</span> (or interest) is the deeper concern, fear, value,
              or hope underneath that position — safety, fairness, freedom, belonging, dignity, stability.
              It's what a person <em>truly cares about</em>.
            </p>
          </div>
          <div className="rounded-xl bg-[#F5F2EA] border border-[#E8E3D9] p-4">
            <p className="font-semibold mb-1.5 text-[#2D2A26]">Why focus on needs?</p>
            <p className="text-[#6E6860]">
              Opposing positions collide — only one can “win.” But the needs beneath them are often
              compatible, and a single need can be met in many different ways. When you look past positions
              to needs, you open room for creative, integrative solutions that satisfy more of what
              <em> both</em> sides genuinely care about, instead of a win-or-lose fight over one fixed demand.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
